import { useContext } from "react";
import PropertyDataContext from "src/contexts/PropertyData/PropertyDataContext";

const usePropertyData = () => useContext(PropertyDataContext);

export default usePropertyData;